import React from 'react'
import useEmblaCarousel from 'embla-carousel-react'
import Autoplay from 'embla-carousel-autoplay'
import { Skeleton, IconButton, darken, } from '@mui/material';
import { IconArrowLeft, IconArrowRight } from '@tabler/icons-react';

import { useScreenSize } from '@context/screenSizeContext'

import "./blogCarousel.css";

import { AssetUrl } from '@configuration/apiEndpoints';

const SLIDES_SKELETON = Array.from(Array(3).keys())

export default function BlogCarousel({ data, loading = false, isError = false }) {
  const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true }, [Autoplay()])
  // const isSmallScreen = useScreenSize();

  const slides = [...data];
  while (slides.length < 3 && slides.length >= 1) {
    slides.push(...data.slice(0, 3 - slides.length));
  }

  const onPressPrevious = () => {
    if (emblaApi) emblaApi.scrollPrev()
  }

  const onPressNext = () => {
    if (emblaApi) emblaApi.scrollNext()
  }


  return (
    <section className="blog_embla">
      <div className="blog_embla__viewport" ref={emblaRef}>
        <div className="blog_embla__container">
          {slides.map((data, index) => (
            <div className="blog_embla__slide" key={index}>
              <img src={data} width={'100%'} height={'100%'} style={{objectFit: 'contain', backgroundColor: '#E5E5E5'}} alt={data?.bannerName}/>
            </div>
          ))}
          {( data.length === 0 ) &&
            SLIDES_SKELETON.map((index) => (
              <div className='blog_embla__slide' key={index}>
                <Skeleton variant="rectangular" width={'100%'} height={'100%'} animation={!isError && 'pulse'}/>
              </div>
            ))
          }
        </div>
      </div>
      {slides.length > 0 && 
      <div style={{
        position: 'absolute',
        bottom: 25,
        right: 25,
        display: 'flex',
        gap: 10
      }}>
        <IconButton onClick={onPressPrevious} color="secondary" aria-label="previous" size='large' sx={{ backgroundColor: '#7CA7AD', color: 'white', '&:hover': { backgroundColor: darken("#7CA7AD", 0.15) } }}>
          <IconArrowLeft size={24}/>
        </IconButton>
        <IconButton onClick={onPressNext} color="secondary" aria-label="next" size='large' sx={{ backgroundColor: '#7CA7AD', color: 'white', '&:hover': { backgroundColor: darken("#7CA7AD", 0.15) } }}>
          <IconArrowRight size={24}/>
        </IconButton>
      </div>
      }
    </section>
  )
}